export default __webpack_public_path__ + "static/media/480_business05-fr-mobile.4d83299f.png";